// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__UDDYf","loader":"Loader_loader__+lRPl","l24":"Loader_l24__DxQxE"};